import React, { useContext, useEffect, useState } from 'react'
import "./PlaceOrder.css"
import { StoreContext } from '../../context/StoreContext'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'

 

const PlaceOrder = () => {

  const navigate = useNavigate();
  const frontend_url = "https://officebites.store"; 
  

  
const {getTotalCartAmount,token,food_list,cartItems,url} = useContext(StoreContext)

const [data,setData] = useState({
  firstName:"",
  lastName:"", 
  number:"",
  street:"",
  building:"",
  county:"",
  mpesa_code:""

}) 

const onChangeHandler = (event) => {
  const name = event.target.name;
  const value = event.target.value;
  setData(data=>({...data,[name]:value}))
}

 //consider removal after testing 
 console.log("food_list:", food_list);
 console.log("cartItems:", cartItems);





 
const placeOrder = async (event) => {
  event.preventDefault();

  let orderItems = [];
  food_list.map((item) => {
    if (cartItems[item._id]>0) {
      let itemInfo = item; // Spread operator to copy item data
      itemInfo["quantity"] = cartItems[item._id];
      orderItems.push(itemInfo);
      
      console.log("itemInfo:", itemInfo); 
      
    }
  })

  console.log(orderItems);
 console.log("orderItems:", orderItems);
  

 let orderData = {
  address:data,
  items:orderItems,
  amount:getTotalCartAmount()+2,
}
console.log("orderData:", orderData);
console.log("getTotalCartAmount result:", getTotalCartAmount());
console.log(token);

 let response = await axios.post(url+"/api/order/place",orderData,{headers:{token}} );    //{header:{token}} // {headers:{ Authorization: `Bearer ${token}` } } 

 console.log(response.data)


 if (response.data.success) {
  
  const  {orderId}  = response.data;
  navigate("/myorders/");

  //navigate("/verify?success=true&orderId=" + orderId);
  
  console.log("Response data:", response.data);
 


  //const {session_url} =`${frontend_url}/verify?success=true&orderId=${orderId}`;    
   //${newOrder._id}
 // window.location.replace(session_url);

   // After successful payment verification on the frontend, 
  // send a request to your backend to update the order status
        //await axios.post(url + "/api/order/verify", { orderId, success: true });
  
   



 
 }
 else {
  alert("Error while placing order");
 }

 
 


}




useEffect(() => {
  if (!token) {
    navigate('/cart')

  }
  else if (getTotalCartAmount()===0)
  {
    navigate('/cart')
  }

},[token])




  
  return (
    <form onSubmit={placeOrder} action="" className="place-order">

<div className="place-order-left">
<p className='title'>Delivery Information</p>
<div className="multi-field">
 <input required name='firstName' onChange={onChangeHandler} value={data.firstName} placeholder="First name" type="text" />
 <input required name='lastName' onChange={onChangeHandler} value={data.lastName} placeholder="Last name" type="text" />
</div>

<input required name='number' onChange={onChangeHandler} value={data.number}type="text" placeholder='Phone Number' />
<input required name='street' onChange={onChangeHandler} value={data.street} type="text"  placeholder='Street'/>

<div className="multi-field">
   < input required  name='building' onChange={onChangeHandler} value={data.building}  type="text" placeholder='Building' />
   <input required  name='county' onChange={onChangeHandler} value={data.county}  type='text' placeholder='County'/>

</div>

 <input required name='mpesa_code' onChange={onChangeHandler} value={data.mpesa_code}  type="text" placeholder='M-pesa code' />

</div>

<div className="place-order-right">

<div className="cart-total">
          <h2>Cart Total</h2>

          <div>
                <div className="cart-total-details">
                  <p>Subtotal</p>
                <p>Ksh {getTotalCartAmount()}
               
                </p>
                
                </div>

                        <div className="cart-total-details">
                          <p>Delivery fee </p>
                        <p>Ksh {getTotalCartAmount()===0?0:15}</p>
                        </div>

                                  <div className="cart-total-details">
                                    <p>Total</p>
                                  <b>Ksh {getTotalCartAmount()===0?0:getTotalCartAmount()+15}                                          </b>
                                  </div>
                                 

                           </div>
                           <div className='M-PESA TILL'>
                                  <span 

className="text-white-500"
>
  <img src="/m-pesa.png" width={60} alt="" /> <p>4974070</p>
  </span>

                                  </div>
                                                                                                                                                                                                                                                                                                                                       
        <button type='submit'>Complete Order</button>

       

        </div>


</div>

    </form>
  )

}


export default PlaceOrder;
 
